import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { UpdateConfiguratorValue } from '../../../Actions/Configurator/Configurator.action';
import { useSelector } from 'react-redux';
import { ConfiguratorConstants } from '../../../Models/Configurator/ConfiguratorConstants';

const RadioButtonInputModule = (props) => {  
    const dispatch = useDispatch();  
    const { configuratorValuesShareData } = useSelector((state) => state.productConfigurator.payload);

    useEffect(() => {
        window.localStorage.setItem(props.moduleInfo.moduleProperty, JSON.stringify(props.moduleInfo.options));
    }, [props]);
    const [activeOption, setActiveOption] = useState(null);

    const handleOptionClick = (optionValue) => {
        setActiveOption(optionValue);
        const moduleTitle = document.getElementById("wallSectionTitle");
        const offset = moduleTitle.getBoundingClientRect().top;
        window.scrollBy({
            top: offset - 80,
            left: 0,
            behavior: 'smooth' 
        });
    };

    useEffect(() => {
        if (configuratorValuesShareData && configuratorValuesShareData.length > 0) {  
            configuratorValuesShareData.map(x => {
                if (x.name === ConfiguratorConstants.WallTypeProperty) {
                    setActiveOption(x.value);                
                } 
            });                                              
        }
    }, [configuratorValuesShareData]);

    return(<Fragment>
        <div className='configurator__option-section-module'>
            <div className='content-wrapper'>
                <h3 className='title' id="wallSectionTitle">{props.moduleInfo.title}</h3>
                <div className="text"
                    dangerouslySetInnerHTML={{
                        __html: props.moduleInfo.text,
                    }} 
                ></div>
                <div className='option-wrapper'>
                     {props.moduleInfo.options && props.moduleInfo.options.map((item) => {
                        return (
                        <>
                            <div
                                key={item.optionValue}
                                className={`option ${activeOption === item.optionValue ? 'active' : ''}`}
                            >
                            <a onClick={() => {
                                    handleOptionClick(item.optionValue);
                                    dispatch(UpdateConfiguratorValue(props.moduleInfo.moduleProperty, item.optionValue));
                                }}>
                                    {item.optionImageUrl && <img src={item.optionImageUrl}></img>}
                                    <p className='name'>
                                        {item.optionName}
                                    </p>
                                </a>
                            </div>
                        </>)
                    })}
                </div>
            </div>
        </div> 
    </Fragment>)
}

export default RadioButtonInputModule;